<b>Collections Due Today</b>
<hr>
<div class="statRow">
  <div class="statNumber">{{ collections.length }}</div>
  <div class="statLabel">Collections scheduled today</div>
</div>
<ul class="miniList">
  @for (collection of collections; track collection) {
    <li>
      <span class="time">{{ collection.time }}</span>
      <span class="details">{{ collection.customer }} — {{ collection.type }}</span>
    </li>
  }
</ul>
